import { render, staticRenderFns } from "./PointLogs.vue?vue&type=template&id=35062cee"
import script from "./PointLogs.vue?vue&type=script&lang=js"
export * from "./PointLogs.vue?vue&type=script&lang=js"
import style0 from "./PointLogs.vue?vue&type=style&index=0&id=35062cee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports